module.exports = __webpack_public_path__ + "img/normal-dice.22089274.png";